import { render, staticRenderFns } from "./AddWaterCompany.vue?vue&type=template&id=b6843e36&"
import script from "./AddWaterCompany.vue?vue&type=script&lang=js&"
export * from "./AddWaterCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports